import React from 'react';
import { B } from '../../context/ThemeContext';
import { Btn, Field } from './UIComponents';

export function ViewMedicationModal({ med, onClose }) {
  if (!med) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
    }} onClick={onClose}>
      <div style={{
        background: B.white, borderRadius: 16, width: '100%', maxWidth: 440,
        padding: 28, boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 800, color: B.navy, marginBottom: 20 }}>Medication Details</div>
        <Field label="Medication" value={med.name} />
        <Field label="Resident" value={med.resident} />
        <Field label="Route" value={med.route} />
        <Field label="Frequency" value={med.freq} />
        <Field label="Next Due" value={med.next} />
        <Field label="Status" value={med.status} />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
          <Btn outline color={B.muted} onClick={onClose}>Close</Btn>
        </div>
      </div>
    </div>
  );
}

export function ViewBillingModal({ claim, onClose }) {
  if (!claim) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 1000,
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
    }} onClick={onClose}>
      <div style={{
        background: B.white, borderRadius: 16, width: '100%', maxWidth: 460,
        padding: 28, boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 16, fontWeight: 800, color: B.navy, marginBottom: 20 }}>Claim Details</div>
        <Field label="Claim ID" value={claim.id} />
        <Field label="Resident" value={claim.resident} />
        <Field label="Payer" value={claim.payer} />
        <Field label="Service" value={claim.service} />
        <Field label="Period" value={claim.period} />
        <Field label="Amount" value={`$${claim.amount?.toLocaleString()}`} />
        <Field label="Status" value={claim.status} />
        <Field label="Submitted" value={claim.submitted} />
        <Field label="Paid Date" value={claim.paid} />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
          <Btn outline color={B.muted} onClick={onClose}>Close</Btn>
          <Btn color={B.blue}>Download EOB</Btn>
        </div>
      </div>
    </div>
  );
}

export default ViewMedicationModal;
